import { HtmlEditor } from "devextreme-react";
import { Toolbar } from "devextreme-react/html-editor";
import { Item } from "devextreme-react/toolbar";
import { useEffect } from "react";
import { useSelector } from "react-redux";

export default function JobDescriptionHtmlEditor(props) {
  const { jobDescrRef } = props;

  const career = useSelector((state) => state.career);

  useEffect(() => {
    jobDescrRef.current.instance.option("value", career.jobDescr);
  }, []);

  //   useEffect(() => {
  //     console.debug("[JobDescriptionHtmlEditor2]");

  //     console.debug("career2", career.jobDescr);
  //   }, [career.jobDescr]);

  return (
    <HtmlEditor
      ref={jobDescrRef}
      height={300}
      valueType={"html"}
      name="jobDescr"
    >
      <Toolbar multiline={true}>
        <Item name="undo" />
        <Item name="redo" />
        <Item name="separator" />
        <Item
          name="size"
          acceptedValues={[
            "8pt",
            "10pt",
            "12pt",
            "14pt",
            "18pt",
            "24pt",
            "36pt",
          ]}
        />
        <Item
          name="font"
          acceptedValues={[
            "Arial",
            "Courier New",
            "Georgia",
            "Impact",
            "Lucida Console",
            "Tahoma",
            "Times New Roman",
            "Verdana",
          ]}
        />
        <Item name="separator" />
        <Item name="bold" />
        <Item name="italic" />
        <Item name="strike" />
        <Item name="underline" />
        <Item name="separator" />
        <Item name="alignLeft" />
        <Item name="alignCenter" />
        <Item name="alignRight" />
        <Item name="alignJustify" />
        <Item name="separator" />
        <Item name="orderedList" />
        <Item name="bulletList" />
        <Item name="separator" />
        <Item name="header" acceptedValues={[false, 1, 2, 3, 4, 5]} />
        <Item name="separator" />
        <Item name="color" />
        <Item name="background" />
        <Item name="separator" />
        <Item name="link" />
        <Item name="separator" />
        <Item name="clear" />
        <Item name="codeBlock" />
        <Item name="blockquote" />
        <Item name="separator" />
        <Item name="insertTable" />
        <Item name="deleteTable" />
        <Item name="insertRowAbove" />
        <Item name="insertRowBelow" />
        <Item name="deleteRow" />
        <Item name="insertColumnLeft" />
        <Item name="insertColumnRight" />
        <Item name="deleteColumn" />
      </Toolbar>
    </HtmlEditor>
  );
}
